// delta-display.component.ts
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-battery-display',
  template: `
  @if(value !== undefined && value !== null){
    <div [class]="'battery-chip ' + getChipSeverity()">
      {{ value }}%
    </div>
  }@else {
    <div [class]="'battery-chip'">
      --
    </div>
  }
  `,
  styles: [`
    .battery-chip{
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.25rem 0.5rem;
      border-radius: var(--p-border-radius-lg);
      background-color: var(--p-surface-200);
      color: var(--p-text-color);
      font-size: 0.9rem;
      line-height: 0.9rem;
      font-weight: 500;
      width: fit-content;

      &.high {
        background-color: rgba(from var(--p-green-600) r g b / 0.1);
        color: var(--p-green-600);
      }
      &.medium {
        background-color: rgba(from var(--p-orange-600) r g b / 0.1);
        color: var(--p-orange-600);
      }
      &.low {
        background-color: rgba(from var(--p-red-600) r g b / 0.1);
        color: var(--p-red-600);
      }
      &.critical {
        background-color: rgba(from var(--p-gray-600) r g b / 0.1);
        color: var(--p-gray-600);
      }
      &.charging {
        background-color: rgba(from var(--p-sky-600) r g b / 0.1);
        color: var(--p-sky-600);
      }
    }
  `],
  imports: [CommonModule]
})
export class BatteryDisplayComponent {
  _value: any
  @Input() set value(v: any) {
    if (v === '<span class="null-chip">null</span>') {
      this._value = null
      return
    }
    this._value = v
  }

  get value() {
    return this._value
  }

  @Input() charging: boolean | undefined

  getChipSeverity(): any {
    if (this.charging) return 'charging';
    if (this.value > 70) return 'high';
    if (this.value > 40) return 'medium';
    if (this.value > 15) return 'low';
    return 'critical';
  }
}